(() => {
  const selectors = {
    container: '[data-cart-compatibility-warnings]'
  };

  const getContainers = () => Array.from(document.querySelectorAll(selectors.container));

  const getRootUrl = () => window.Shopify?.routes?.root || '/';

  const fetchCart = async () => {
    const response = await fetch(`${getRootUrl()}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return { items: [] };
    return response.json();
  };

  const formatIncompatibleLabel = (item, matchType) => {
    if (matchType === 'variant' && item.variant_title) {
      return `${item.product_title} - ${item.variant_title}`;
    }
    return item.product_title;
  };

  const applyTokens = (message, sourceItem, incompatibleLabel) => (
    message
      .replaceAll('{{ source_product }}', sourceItem.product_title)
      .replaceAll('{{source_product}}', sourceItem.product_title)
      .replaceAll('{{ incompatible_product }}', incompatibleLabel)
      .replaceAll('{{incompatible_product}}', incompatibleLabel)
  );

  const createIcon = (iconUrl) => {
    if (iconUrl) {
      const img = document.createElement('img');
      img.src = iconUrl;
      img.alt = '';
      img.className = 'icon-sm flex-shrink-0';
      img.style.width = '20px';
      img.style.height = '20px';
      img.style.objectFit = 'contain';
      return img;
    }
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'icon icon-alert-circle icon-sm flex-auto');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('d', 'M12 16V11M12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8M12.5 8C12.5 7.72386 12.2761 7.5 12 7.5C11.7239 7.5 11.5 7.72386 11.5 8M12.5 8H11.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z');
    svg.appendChild(path);
    return svg;
  };

  const buildAlert = (heading, message, bgColor, textColor, iconUrl) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'alert alert--info flex items-start gap-3 text-sm md:text-base leading-tight';
    if (bgColor) wrapper.style.backgroundColor = bgColor;
    if (textColor) wrapper.style.color = textColor;
    const content = document.createElement('div');
    content.className = 'grid gap-1';
    const headingEl = document.createElement('p');
    headingEl.className = 'font-medium leading-tight';
    headingEl.textContent = heading;
    const messageEl = document.createElement('p');
    messageEl.textContent = message;
    content.append(headingEl, messageEl);
    wrapper.append(createIcon(iconUrl), content);
    return wrapper;
  };

  const renderCompatibilityWarnings = async () => {
    const containers = getContainers();
    if (!containers.length) return;

    containers.forEach((c) => { c.innerHTML = ''; c.hidden = true; });

    const activeContainers = containers.filter((c) => c.dataset.enabled !== 'false');
    if (!activeContainers.length) return;

    let rules = [];
    try {
      rules = JSON.parse(activeContainers[0].dataset.rules || '[]');
    } catch { return; }
    if (!rules.length) return;

    const cart = await fetchCart();
    const items = cart.items || [];
    if (!items.length) return;

    const warnings = [];
    const seen = new Set();

    rules.forEach((rule) => {
      const sourceProductId = Number(rule.sourceProductId);
      const incompatibleProductIds = new Set((rule.incompatibleProductIds || []).map(Number));
      const incompatibleVariantIds = new Set((rule.incompatibleVariantIds || []).map(Number));

      const sourceItem = items.find((item) => Number(item.product_id) === sourceProductId);
      if (!sourceItem) return;

      items.forEach((targetItem) => {
        if (Number(targetItem.product_id) === sourceProductId) return;

        let matchType = null;
        if (incompatibleVariantIds.size && incompatibleVariantIds.has(Number(targetItem.variant_id))) {
          matchType = 'variant';
        } else if (incompatibleProductIds.size && incompatibleProductIds.has(Number(targetItem.product_id))) {
          matchType = 'product';
        }
        if (!matchType) return;

        const incompatibleLabel = formatIncompatibleLabel(targetItem, matchType);
        const rawMessage = rule.message || activeContainers[0].dataset.defaultMessage || '';
        const message = applyTokens(rawMessage, sourceItem, incompatibleLabel);
        const targetId = matchType === 'variant' ? targetItem.variant_id : targetItem.product_id;
        const key = `${sourceProductId}-${matchType}-${targetId}-${message}`;

        if (seen.has(key)) return;
        seen.add(key);
        warnings.push({ message });
      });
    });

    if (!warnings.length) return;

    activeContainers.forEach((container) => {
      const heading = container.dataset.heading;
      const bgColor = container.dataset.bgColor || '';
      const textColor = container.dataset.textColor || '';
      const iconUrl = container.dataset.iconUrl || '';
      warnings.forEach((w) => container.appendChild(buildAlert(heading, w.message, bgColor, textColor, iconUrl)));
      container.hidden = false;
    });
  };

  document.addEventListener('DOMContentLoaded', renderCompatibilityWarnings);
  document.addEventListener('cart:updated', renderCompatibilityWarnings);
  document.addEventListener('cart:refresh', () => setTimeout(renderCompatibilityWarnings, 150));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[aria-controls="CartDrawer"]')) {
      setTimeout(renderCompatibilityWarnings, 150);
    }
  });
})();
